import { FC, useContext, useMemo } from 'react'
import { useDealContext } from '../DealContext'
import { SpecsContext } from '../SpecsContext'
import { Progress, Spinner, Text } from '@agro-club/agroclub-shared'
import { useTranslation } from 'react-i18next'
import { DealPeriodsTypes } from 'modules/domain/deal/types'
import useFormatDate from 'hooks/useFormatDate'
import styled from 'styled-components'
import { KeyValue } from 'views/components/KeyValue/KeyValue'

const Container = styled.div`
  display: flex;
  gap: 50px;
  margin-bottom: 8px;
  margin-top: 16px;
`
const Header = styled.div`
  display: flex;
`

const ColContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const useFormatShortDate = () => {
  const formatDate = useFormatDate()
  return (dateString: string | null) => {
    return dateString ? formatDate(dateString, { dateFormat: 'ddMM' }) : '???'
  }
}
export const DatesBlock: FC = () => {
  const { t } = useTranslation('deal')
  const { deal, dealPeriods, progressDealPeriods } = useDealContext()
  const formatShortDate = useFormatShortDate()
  const loadingDealPeriod = useMemo(
    () => dealPeriods?.find((p) => p.period_type === DealPeriodsTypes.loading),
    [dealPeriods],
  )
  const deliveryDealPeriod = useMemo(
    () => dealPeriods?.find((p) => p.period_type === DealPeriodsTypes.delivery),
    [dealPeriods],
  )
  const { sellerSpecInfo, customerSpecInfo } = useContext(SpecsContext)
  const customerSpec = useMemo(() => {
    return customerSpecInfo.data?.find((s) => s.id === deal.purchase_specification?.id)
  }, [customerSpecInfo.data, deal])

  const sellerSpec = sellerSpecInfo.data[0]

  //sellerSpecInfo.progress = Progress.WORK
  if (
    sellerSpecInfo.progress !== Progress.SUCCESS ||
    customerSpecInfo.progress !== Progress.SUCCESS ||
    progressDealPeriods !== Progress.SUCCESS
  ) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Spinner />
      </div>
    )
  }
  if (!sellerSpec && !customerSpec && dealPeriods?.length === 0) {
    return null
  }
  return (
    <Container>
      <ColContainer>
        <Header>
          <Text typography="accentLarge">{t('operationsDates')}</Text>
        </Header>
        {loadingDealPeriod && (
          <KeyValue label={t('loadingPlan')}>
            {formatShortDate(loadingDealPeriod?.start_date)} {' - '}
            {formatShortDate(loadingDealPeriod?.end_date)}
          </KeyValue>
        )}
        {deliveryDealPeriod && (
          <KeyValue label={t('unloadingPlan')}>
            {formatShortDate(deliveryDealPeriod?.start_date)} {' - '}
            {formatShortDate(deliveryDealPeriod?.end_date)}
          </KeyValue>
        )}
      </ColContainer>
      <ColContainer>
        <Header>
          <Text typography="accentLarge">{t('contractDates')}</Text>
        </Header>

        {sellerSpec && (
          <KeyValue label={t('selllerSpecDates')}>
            {formatShortDate(sellerSpec.loading_start_date)}
            {' - '}
            {formatShortDate(sellerSpec.loading_end_date)}
          </KeyValue>
        )}
        {customerSpec?.deadline && (
          <KeyValue label={t('customerSpecDate')}>
            {t('common:until')} {formatShortDate(customerSpec.deadline)}
          </KeyValue>
        )}
      </ColContainer>
    </Container>
  )
}
